import _ from 'lodash';

export const CLASSES = _.map([{
  id: 1,
  mask: 1,
  name: 'Warrior',
  armorTypes: ['misc', 'plate', 'shield'],
}, {
  id: 2,
  mask: 2,
  name: 'Paladin',
  armorTypes: ['misc', 'plate', 'shield'],
}, {
  id: 3,
  mask: 4,
  name: 'Hunter',
  armorTypes: ['misc', 'mail'],
}, {
  id: 4,
  mask: 8,
  name: 'Rogue',
  armorTypes: ['misc', 'leather'],
}, {
  id: 5,
  mask: 16,
  name: 'Priest',
  armorTypes: ['misc', 'cloth'],
}, {
  id: 6,
  mask: 32,
  name: 'Death Knight',
  armorTypes: ['misc', 'plate'],
}, {
  id: 7,
  mask: 64,
  name: 'Shaman',
  armorTypes: ['misc', 'mail', 'shield'],
}, {
  id: 8,
  mask: 128,
  name: 'Mage',
  armorTypes: ['misc', 'cloth'],
}, {
  id: 9,
  mask: 256,
  name: 'Warlock',
  armorTypes: ['misc', 'cloth'],
}, {
  id: 10,
  mask: 512,
  name: 'Monk',
  armorTypes: ['misc', 'leather'],
}, {
  id: 11,
  mask: 1024,
  name: 'Druid',
  armorTypes: ['misc', 'leather'],
}, {
  id: 12,
  mask: 2048,
  name: 'Demon Hunter',
  armorTypes: ['misc', 'leather'],
}], c => {
  return {
    ...c,
    nameSearch: _.toLower(_.camelCase(c.name)),
  };
});

export const CLASS_ID_MAP = _.fromPairs(_.map(CLASSES, c => [c.name, c.id]));
